export default __webpack_public_path__ + "static/hero_mobile_large-9ca0aa9d018d61d316f36662a0fedb29.webp";